export class Statuses {
    static start: number = 1;
    static ticketFound: number = 2;
    static ticketNotFound: number = 3;
    static scheduleAppointment: number = 4;
    static editAppointment: number = 5;
    static viewAppointment: number = 6;
}